import { Box, MenuItem, Select } from '@mui/material';

import { FormControl, InputLabel } from '@mui/material';
import type { ReactNode } from 'react';

type Props = {
  label: string;
  value: string;
  labelId: string;
  options: Array<{ label: string; value: string; icon?: ReactNode }>;
  onChange: (value: string) => void;
  required?: boolean;
  disabled?: boolean;
};

export default function SelectInput({
  label,
  labelId,
  options,
  value,
  onChange,
  required,
  disabled,
}: Props) {
  return (
    <FormControl fullWidth>
      <InputLabel id={labelId} required={required}>
        {label}
      </InputLabel>
      <Select
        labelId={labelId}
        value={value}
        label={label}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.icon ? (
              <Box
                component="span"
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 1,
                  color: 'text.secondary',
                }}
              >
                <Box
                  component="span"
                  sx={{ display: 'inline-flex', alignItems: 'center' }}
                >
                  {option.icon}
                </Box>
                <Box component="span" sx={{ color: 'text.primary' }}>
                  {option.label}
                </Box>
              </Box>
            ) : (
              option.label
            )}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
